module.exports = __webpack_public_path__ + "img/10a1736.jpg";